module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/desktop-banner-414bc146fe220eb2218fae16bad9c40b.webp";